export class BaseResponseDto<T> {
  public errorCode!: number;
  public errorMessage!: string;
  public data!: T;
}
